module.exports = __webpack_public_path__ + "static/media/MSMEBen3.df9b4767.svg";